<template>
	<div :class="'message-left-border xxs pl-sm pt-xs pr-sm pb-xs ' + borderClass">
		<div v-if="isInformation" class="flex flex-row items-start gap-xs">
			<div class="max-w-bs min-w-bs pt-xxs max-h-bs"><InformationIcon /></div>

			<div class="information-text" v-html="message"></div>
		</div>
		<div v-if="isQuestion" class="flex flex-row items-start gap-xs">
			<div class="max-w-bs min-w-bs pt-xxs max-h-bs"><QuestionMessageIcon fill-color="var(--primary)" /></div>
			<div class="question-text" v-html="message"></div>
		</div>
	</div>
</template>

<script>
	import { InformationIcon, QuestionMessageIcon } from '@/components/icons';
	import { MessageTypes } from '@/constants';
	export default {
		name: 'OaoFormMessage',
		components: {
			InformationIcon,
			QuestionMessageIcon
		},
		props: {
			messageType: {
				type: Number,
				required: false,
				default: 0
			},
			message: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				messageInfoType: this.messageType
			};
		},
		computed: {
			isInformation() {
				return this.messageType == MessageTypes.INFORMATION;
			},
			isQuestion() {
				return this.messageType == MessageTypes.QUESTION;
			},
			borderClass() {
				return this.messageType == MessageTypes.QUESTION ? 'question-box' : 'message-box';
			}
		}
	};
</script>

<style lang="scss" scoped>
	.message-left-border {
		background: #f0f0f0;
	}
	.question-box {
		background: var(--primary-25);
		border-left: 4px solid var(--text-primary);
	}
	.message-box {
		background: #f0f0f0;
		border-left: 4px solid var(--text-body);
	}
	.question-text {
		color: var(--primary);
	}
	.information-text {
		color: var(--text-body);
	}
</style>
